// 控制 POS 多裝置同步的前端事件中心。
// 後端資料庫仍是唯一正式來源；此服務只通知各畫面重新向 API 取得最新資料。
class RealtimeSyncService {
  constructor() {
    this.timer = null;
    this.intervalMs = 3000;
    this.visibilityHandler = null;
    this.onlineHandler = null;
  }

  // 控制啟動三秒備援刷新，避免 SignalR 漏訊息或舊 API 尚未發送事件時畫面不同步。
  start(intervalMs = 3000) {
    this.intervalMs = Math.max(2000, Number(intervalMs) || 3000);
    if (this.timer) return;

    this.timer = window.setInterval(() => {
      if (document.visibilityState === "visible" && navigator.onLine) {
        this.requestRefresh("fallback-polling", "all");
      }
    }, this.intervalMs);

    this.visibilityHandler = () => {
      if (document.visibilityState === "visible") {
        this.requestRefresh("app-resumed", "all", true);
      }
    };

    this.onlineHandler = () => {
      this.requestRefresh("network-restored", "all", true);
    };

    document.addEventListener("visibilitychange", this.visibilityHandler);
    window.addEventListener("online", this.onlineHandler);
  }

  // 控制停止計時器與系統事件，避免 Vue 元件卸載後重複刷新。
  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    if (this.visibilityHandler) {
      document.removeEventListener("visibilitychange", this.visibilityHandler);
      this.visibilityHandler = null;
    }

    if (this.onlineHandler) {
      window.removeEventListener("online", this.onlineHandler);
      this.onlineHandler = null;
    }
  }

  // 控制發出統一同步事件；resource 可為 table、order、cart、menu、member、setting 或 all。
  requestRefresh(reason, resource = "all", force = false, detail = null) {
    window.dispatchEvent(
      new CustomEvent("store-data-refresh-requested", {
        detail: {
          reason,
          resource,
          force,
          payload: detail,
          requestedAt: new Date().toISOString(),
        },
      })
    );
  }
}

const realtimeSyncService = new RealtimeSyncService();
export default realtimeSyncService;
